import { render, staticRenderFns } from "./CierreQualitasCr.vue?vue&type=template&id=6b66072e&"
import script from "./CierreQualitasCr.vue?vue&type=script&lang=js&"
export * from "./CierreQualitasCr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports